import Vue from 'vue';
import { cloneDeep } from 'lodash';

import { E勘定科目カテゴリ } from '@/openapi/enum';
import { 勘定科目ListItemResponse } from '@/openapi/user';

import { new勘定科目ListItemResponse } from '@/entries/user/mixins/勘定科目Mixin';

type State = {
  isEditing勘定科目: boolean;
  e勘定科目カテゴリ: E勘定科目カテゴリ;
  edit勘定科目: 勘定科目ListItemResponse | null;
  is勘定科目ListEditMode: boolean;
};

const state = Vue.observable<State>({
  isEditing勘定科目: false,
  e勘定科目カテゴリ: E勘定科目カテゴリ.貸借,
  edit勘定科目: null,
  is勘定科目ListEditMode: false,
});

export default Vue.extend({
  name: 'M勘定科目ListEditMixin',

  computed: {
    isEditing勘定科目(): boolean {
      return state.isEditing勘定科目;
    },
    e勘定科目カテゴリ(): E勘定科目カテゴリ {
      return state.e勘定科目カテゴリ;
    },
    edit勘定科目(): 勘定科目ListItemResponse {
      return state.edit勘定科目 !== null ? state.edit勘定科目 : new勘定科目ListItemResponse();
    },
    is勘定科目ListEditMode(): boolean {
      return state.is勘定科目ListEditMode;
    },
    isNew勘定科目(): boolean {
      return this.edit勘定科目.pk === 0;
    },
  },

  methods: {
    start勘定科目Create(e勘定科目カテゴリ: E勘定科目カテゴリ): void {
      state.e勘定科目カテゴリ = e勘定科目カテゴリ;
      state.edit勘定科目 = new勘定科目ListItemResponse();
      state.isEditing勘定科目 = true;
    },
    start勘定科目Update(item: 勘定科目ListItemResponse): void {
      state.isEditing勘定科目 = true;
      state.e勘定科目カテゴリ = item.cカテゴリ;
      state.edit勘定科目 = cloneDeep(item);
    },
    end勘定科目Edit(): void {
      state.isEditing勘定科目 = false;
      state.e勘定科目カテゴリ = E勘定科目カテゴリ.貸借;
      state.edit勘定科目 = null;
    },
    toggle勘定科目ListEditMode(): void {
      state.is勘定科目ListEditMode = !state.is勘定科目ListEditMode;
    },
  },
});
